import { __ } from '@wordpress/i18n';

/**
 * Handle the select filter change.
 * @param {object} event The event object.
 */
const handleSelectChange = ( event ) => {
	const { target: select } = event;
	const regionsContainer = document.querySelector( select.getAttribute( 'data-target' ) );
	const regions = Array.from( regionsContainer.querySelectorAll( '[data-sort-region]' ) );

	regions.forEach( ( region ) => {
		const sortby = region.getAttribute( 'data-sort-by' );

		// Show the rest.
		region.style.display = 'none';

		if ( sortby === select.value ) {
			region.removeAttribute( 'style' );
		}
	} );

	// Update the status message to read how many tabs are open.
	const statusMessage = document.getElementById( 'msr-sort-publications-status' );
	if ( statusMessage ) {
		statusMessage.textContent = __( `Accordion below updated to show ${ regions.length } open tabs sorted by ${ select.options[select.selectedIndex].text }.`, 'ms-research' );
	}
};

/**
 * Setup the select.
 * @param {Node} select Region element to setup.
 */
const setupRegionSelect = ( select ) => {
	const regionsContainer = document.querySelector( select.getAttribute( 'data-target' ) );

	// Bail early.
	if ( ! regionsContainer ) {
		return;
	}

	const regions = Array.from( regionsContainer.querySelectorAll( '[data-sort-region]' )  );

	regions.forEach( ( region ) => {
		//skip if is selected
		if ( select.value === region.dataset.sortBy ) {
			return;
		}

		// Show the rest.
		region.style.display = 'none';
	} );

	select.addEventListener( 'change', handleSelectChange );
};

/**
 * Init
 */
const init = () => {
	const selects = Array.from( document.querySelectorAll( '.sort-region-select' ) );

	// Bail early.
	if ( ! selects.length ) {
		return;
	}

	selects.forEach( select => {
		setupRegionSelect( select );
	} );

};

export default init;
